"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.App = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ModalContext_1 = require("./context/ModalContext");
const Modal_1 = require("./modal/Modal");
const ModalBody_1 = require("../../../../engine/admin/static/llm-modal/modal/ModalBody");
const adminApiUtil_1 = require("./common/adminApiUtil");
const textUtil_1 = require("./common/textUtil");
const ModalFooter_1 = require("./modal/ModalFooter");
const getCleanState = (initAction, prevState) => {
    var _a, _b, _c, _d, _e;
    return Object.assign(Object.assign({}, initAction), { initPrompt: '', promptId: (_a = prevState === null || prevState === void 0 ? void 0 : prevState.promptId) !== null && _a !== void 0 ? _a : initAction.promptId, targetContent: (_c = (_b = prevState === null || prevState === void 0 ? void 0 : prevState.targetContent) !== null && _b !== void 0 ? _b : initAction.targetText) !== null && _c !== void 0 ? _c : (0, textUtil_1.getTargetText)(initAction.target), editMode: false, responses: [], showResponseIndex: 0, objectPrompts: (_d = prevState === null || prevState === void 0 ? void 0 : prevState.objectPrompts) !== null && _d !== void 0 ? _d : [], title: (_e = prevState === null || prevState === void 0 ? void 0 : prevState.title) !== null && _e !== void 0 ? _e : initAction.title, loading: true, loadingResponse: false, updateState: undefined });
};
const App = (props) => {
    const [state, setState] = (0, react_1.useState)(getCleanState(props.llmAction));
    const updateState = (data) => {
        setState((prevState) => {
            return Object.assign(Object.assign({}, prevState), data);
        });
    };
    (0, react_1.useEffect)(() => {
        const newState = getCleanState(props.llmAction, state);
        setState(newState);
        (0, adminApiUtil_1.getPromptData)((0, adminApiUtil_1.getModalDataRequestBody)(newState)).then((val) => {
            updateState({ title: val.title, initPrompt: val.prompt, objectPrompts: val.prompts });
            updateState({ loading: false });
        });
    }, [props.llmAction, state === null || state === void 0 ? void 0 : state.promptId]);
    return ((0, jsx_runtime_1.jsx)(ModalContext_1.ModalContext.Provider, { value: Object.assign(Object.assign({}, state), { updateState }), children: (0, jsx_runtime_1.jsxs)(Modal_1.Modal, { close: props.close, displayStyle: props.displayStyle, children: [(0, jsx_runtime_1.jsx)(ModalBody_1.ModalBody, {}), (0, jsx_runtime_1.jsx)(ModalFooter_1.ModalFooter, { close: props.close })] }) }));
};
exports.App = App;
